"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _simplePlanBoxSection = _interopRequireDefault(require("../simple-plan-box-section"));
/**
 * SimplePlanBoxDed4VariantSection, extends SimplePlanBoxSection Component.
 * @param {Object} props React props
 * @param {String} props.id An unique identifier
 * @param {Array} props.apiUrls A string array of VPS4 availability endpoints to check
 * @param {String} props.outOfStockText Text to be shown if package is out of stock
 * @param {Object} props.passThroughParams Params to be passed through to SimplePlanBoxSection
 * @returns {React.ReactElement} SimplePlanBoxDed4VariantSection Component
 * @public
 */

function SimplePlanBoxDed4VariantSection({
  id,
  apiUrls,
  outOfStockText,
  ...passThroughParams
}) {
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const [apiResponse, setApiResponse] = (0, _react.useState)([]);
  const apiResponses = {},
    setApiResponses = {};
  for (const apiUrl of apiUrls) {
    apiResponses[apiUrl] = apiResponse;
    setApiResponses[apiUrl] = setApiResponse;
  }
  (0, _react.useEffect)(() => {
    setIsLoading(true);
    const promises = apiUrls.map(async apiUrl => {
      const res = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          accept: 'application/json'
        }
      });
      const packages = await res.json();
      setApiResponses[apiUrl](packages);
    });
    Promise.all(promises).then(() => {
      setIsLoading(false);
    });
  }, [apiUrls]);
  const commonPackages = Object.values(apiResponses).reduce((a, c) => a.filter(p => c.includes(p)));

  // eslint-disable-next-line new-cap
  return (0, _simplePlanBoxSection.default)({
    id,
    disabledPackages: {
      isLoading,
      message: outOfStockText,
      value: commonPackages
    },
    ...passThroughParams
  });
}
var _default = exports.default = SimplePlanBoxDed4VariantSection;
SimplePlanBoxDed4VariantSection.propTypes = {
  id: _propTypes.default.string,
  apiUrls: _propTypes.default.arrayOf(_propTypes.default.string),
  outOfStockText: _propTypes.default.string,
  passThroughParams: _propTypes.default.object
};